import { useAuth } from 'context/AuthContext';
import { useState } from 'react';
import { purchaseItem } from 'services/store.service';
import './style.scss';
import Modal from '../modal';

const BoxStore = (props: any) => {
  const [resgatar, setResgatar] = useState(false);
  const [loading, setloading] = useState(false);
  const [isResgated, setisResgated] = useState(false);
  const [showInfo, setShowInfo] = useState(false);
  const { user, refreshUser } = useAuth();
  const [showModal, setShowModal] = useState(false);

  function confirmResgate() {
    setloading(true);
    if (user?._id) {
      purchaseItem(props.data._id, 'me').then(data => {
        if (data.status === 'OK') {
          setisResgated(true);
          props.onPurchase();
        } else if (data.status === 'UNAUTHORIZED') {
          if (data?.restrictions?.find((e: string) => e === 'limite_de_compra_excedido')) {
          } else if (data?.restrictions?.find((e: string) => e === 'data_posse_menor_que_90_dias')) {
          } else {
          }

          setResgatar(false);
          setisResgated(false);
        } else {
        }
        setloading(false);
      });
    }
  }

  function showValue() {
    const value = props.data.requires.length ? props.data.requires.find((e: any) => e.item === 'coin') : 0;
    return value?.total ? value?.total : 0;
  }

  return (
    <>
      <div
        className={`
        box-store w-full
        ${props.data.amout <= props.data.owned && props.data.amout !== -1 ? 'disabled' : ''}
        ${resgatar ? 'resgatar' : ''}
        ${isResgated ? 'isResgated' : ''}
        ${user?.point_categories?.coin < showValue() ? 'no-ammount' : ''}
      `}
        tabIndex={0}
        aria-label={`
          ${resgatar ? 'resgatar' : ''}
          ${isResgated ? 'resgatado' : ''}`}
      >
        <figure>
          <img
            src={props.data?.image?.medium?.url || require('../../../assets/img/no-image.png')}
            aria-hidden={true}
            alt="Loja"
          />
        </figure>
        {isResgated ? (
          <div className="text-store">
            <h2>Parabéns!</h2>
            <p>Você resgatou esse item.</p>
            <button
              onClick={() => {
                setResgatar(false);
                setisResgated(false);
              }}
            >
              Fechar
            </button>
          </div>
        ) : (
          <div className="text-store">
            <p aria-label={`${props.data.name}. ${props.data?.description}`} tabIndex={0}>
              {props.data?.name} <br />
              {props.data?.description}
            </p>
            <div className="currency" aria-label={`Valor: ${showValue()} ${showValue() > 1 ? 'moedas' : 'moeda'}`} tabIndex={0}>
              {/* <Currency aria-hidden={true} /> */}
              {/* <span aria-hidden={true}>{showValue()}</span> */}
              {resgatar && (
                <div className="more-info">
                  <h2>Já é quase seu!</h2>
                  <p>Você completou todas as ações e já pode resgatar o seu presente.</p>
                  {/* <span>
                    <b>Saldo atual: </b>
                    <div className="currency">
                      <Currency />
                      <span>{user?.point_categories?.coin || 0}</span>
                    </div>
                  </span> */}
                </div>
              )}
            </div>
            {props.data.amout > props.data.owned || props.data.amout !== -1 ? (
              <div className="resgatar">
                {resgatar ? (
                  <div className="confirm-resgate">
                    <button
                      disabled={loading}
                      onClick={() => {
                        setShowModal(true);
                        setResgatar(false);
                      }}
                      aria-label="Confirmar resgate"
                    >
                      {loading ? 'resgatando...' : 'Confirmar resgate'}
                    </button>
                    <button disabled={loading} onClick={() => setResgatar(false)}>
                      Cancelar
                    </button>
                  </div>
                ) : (
                  <>
                    <p tabIndex={0} aria-label={`Quantidade disponível de: ${props.data.amount - props.data.owned}`}>
                      <strong>Quantidade disponível:</strong>{' '}
                      {props.data.amount !== -1 ? props.data.amount - props.data.owned : 'Ilimitado'}
                    </p>

                    <>
                      {props.disabled ? (
                        <>
                          {props?.data?.purchased > 0 ? (
                            <button disabled={true}>Presente escolhido</button>
                          ) : props.disabled === 'purchased' ? (
                            <button disabled={true}>Você já escolheu seu presente.</button>
                          ) : (
                            <button disabled={true}>Disponível ao concluir todas as ações</button>
                          )}
                        </>
                      ) : (
                        <button onClick={() => setResgatar(true)}>Resgatar</button>
                      )}
                    </>
                  </>
                )}
              </div>
            ) : (
              <div className="esgotado">Esgotado</div>
            )}
          </div>
        )}

        {props.disabled && (
          <div className="tooltip">
            {/* {user?.point_categories?.coin < showValue() && (
              <div className="content-tooltip">
                <p>Você não possui pontuação o suficiente para resgatar esse item.</p>
                <div className="currency">
                  <b>Saldo atual: </b>
                  <span>{user?.point_categories?.coin || 0} moedas</span>
                </div>
              </div>
            )} */}

            {props.disabled && (
              <>
                {props.disabled === 'purchased' ? (
                  <div className="content-tooltip">
                    <p>Você já escolheu seu presente.</p>
                  </div>
                ) : (
                  <div className="content-tooltip">
                    <p>Você não concluiu todas as ações ainda.</p>
                    <div className="currency">
                      <b>Ações: </b>
                      <span className="ml-2">
                        {' '}
                        {props?.total?.completed}/{props?.total?.total}
                      </span>
                    </div>
                  </div>
                )}
              </>
            )}
          </div>
        )}
      </div>
      <div className={`${resgatar ? 'mask-show' : 'mask-hide'}`}></div>

      {showModal && (
        <Modal
          data={props.address}
          onConfirm={() => {
            confirmResgate();
          }}
          onClose={() => {
            setShowModal(false);
            refreshUser();
          }}
        />
      )}
    </>
  );
};

export default BoxStore;
